import { useQuery } from "react-query";
import {
	fetchEarmold,
	fetchEarmoldsPaginated,
	fetchEarmoldVariants,
	fetchEarmoldVariantsPaginated,
} from "../queries/earmold.queries";
import type { PaginatedFilter } from "../types/axios.types";

export const useEarmoldVariantsPaginated = (
	id: number | string | undefined,
) => {
	return (
		page?: number,
		size?: number,
		search?: string,
		filters?: PaginatedFilter,
		sortBy?: string[],
	) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const query = useQuery(
			["earmold-variants", id, page, size, search, filters, sortBy],
			() => {
				try {
					return fetchEarmoldVariantsPaginated(
						id,
						page,
						size,
						search,
						filters,
						sortBy,
					);
				} catch (err) {
					return null;
				}
			},
			{ keepPreviousData: true },
		);
		return query?.data;
	};
};

export const useEarmoldsPaginated = (
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
) => {
	const query = useQuery(
		["earmolds-paginated", page, size, search, filters, sortBy],
		() => {
			try {
				return fetchEarmoldsPaginated(page, size, search, filters, sortBy);
			} catch (err) {
				return null;
			}
		},
		{ keepPreviousData: true },
	);
	return query?.data;
};

export const useEarmold = (id: number | string | undefined) => {
	return useQuery(["earmolds", id], () => {
		try {
			return fetchEarmold(id);
		} catch (err) {
			return null;
		}
	});
};

export const useEarmoldVariants = (id: number | string | undefined) => {
	return useQuery(["earmolds-variants", id], () => {
		try {
			return fetchEarmoldVariants(id);
		} catch (err) {
			return null;
		}
	});
};
